/**
 * DashboardUIContext — 대시보드 편집 모드 state 를 좌측 사이드바와 공유
 *
 * 흐름:
 *   AppShell (provider) 가 워크스페이스 루트에 wrapping
 *     └─ AppSidebar (consumer) — editMode true 면 위젯 갤러리 모드로 변신
 *     └─ /dashboard page (consumer) — editMode/setEditMode 사용
 */
"use client";

import { createContext, useContext, useState, type ReactNode } from "react";

interface DashboardUI {
  editMode: boolean;
  setEditMode: (v: boolean) => void;
}

const DashboardUIContext = createContext<DashboardUI>({
  editMode: false,
  setEditMode: () => { /* noop */ },
});

export function DashboardUIProvider({ children }: { children: ReactNode }) {
  const [editMode, setEditMode] = useState(false);
  return (
    <DashboardUIContext.Provider value={{ editMode, setEditMode }}>
      {children}
    </DashboardUIContext.Provider>
  );
}

export const useDashboardUI = () => useContext(DashboardUIContext);
